const ProfileSectionWrapper = ({ children }: ComponentWithChildren): JSX.Element => {
  return <section className="-mx-6 md:-mx-12 lg:-mx-20">{children}</section>;
};

export default ProfileSectionWrapper;
